import React from "react";
import OfferCard from "./OffreCard";
import { AffariyetEntity } from "gql-types";
import { usePathname } from "next/navigation";
import { routes } from "helpers/routes";

type AffariyetPropsType = {
  affariyet: AffariyetEntity[];
  fromStore?: boolean;
};

function Affariyet({ affariyet, fromStore = false }: AffariyetPropsType) {
  const pathName = usePathname();
  return (
    <div
      className={`
        ${
          pathName === routes.HOME_PATH
            ? "flex overflow-x-auto snap-x snap-mandatory  md:overflow-hidden md:snap-none scroll-smooth  no-scrollbar"
            : "grid grid-cols-1 xl:grid-cols-4"
        } gap-4 md:gap-8    md:grid md:grid-cols-2 lg:grid-cols-3  `}
    >
      {affariyet?.map((offer: AffariyetEntity) => (
        <div
          className="flex-shrink-0 lg:flex-auto  snap-start max-w-[250px] md:max-w-none scroll-mx-16"
          key={offer.id}
        >
          <OfferCard
            offerImage={offer.attributes?.image.data?.attributes?.url as string}
            storeImage={
              offer.attributes?.store?.data?.attributes?.mainImage?.data?.attributes?.url as string
            }
            storeName={offer.attributes?.store?.data?.attributes?.name as string}
            storeSlug={offer.attributes?.store?.data?.attributes?.slug as string}
            categorySlug={
              offer.attributes?.store?.data?.attributes?.sub_category?.data?.attributes?.category
                ?.data?.attributes?.slug as string
            }
            publicationUrl={offer.attributes?.url as string}
            fromStore={fromStore}
          />
        </div>
      ))}
    </div>
  );
}

export default Affariyet;
